import ProtectedRoute from 'components/ProtectedRoute'
import useFlag from 'hooks/useFlag'
import { useGiftCardsAccess } from 'hooks/useGiftCardsAccess'
import React from 'react'
import { Redirect, Route, Switch } from 'react-router'
import Landing from './Landing'

const GiftCards: React.FC = () => {
  const { show } = useGiftCardsAccess()
  const rbacEnabled = useFlag('role-based-access-control', false)

  if (!show) {
    return <Redirect to="/" />
  }

  return (
    <Switch>
      {/* Same RBAC-off carve-out as useGiftCardsAccess (nav item). */}
      {rbacEnabled ? (
        <ProtectedRoute
          redirect="/"
          resource="DigitalExperiences"
          accessType="access"
          exact
          path="/gift_cards"
          component={Landing}
        />
      ) : (
        <Route exact path="/gift_cards" component={Landing} />
      )}
    </Switch>
  )
}

export default GiftCards
